/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ZhongCai.vue?vue&type=template&id=7dfb4c4e&scoped=true&"
import script from "./ZhongCai.vue?vue&type=script&lang=js&"
export * from "./ZhongCai.vue?vue&type=script&lang=js&"
import style0 from "./ZhongCai.vue?vue&type=style&index=0&id=7dfb4c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfb4c4e",
  null
  
)

export default component.exports